import { ReactNode, useMemo } from 'react';
import { getEnvShopifyGraphQLGatewayConfig, ShopifyGraphQLGatewayProvider } from 'hooks/shopify';

/**
 * Routes useShopifyGraphQLSWR through the backend Shopify GraphQL proxy when
 * VITE_APP_SHOPIFY_GRAPHQL_MODE is set to 'proxy'. With 'shopify' (or unset) the hook
 * keeps its direct App Bridge path (config stays null).
 */
const ShopifyGraphQLGatewaySwitch = ({ children }: { children: ReactNode }) => {
    const config = useMemo(() => getEnvShopifyGraphQLGatewayConfig(), []);

    return <ShopifyGraphQLGatewayProvider config={config}>{children}</ShopifyGraphQLGatewayProvider>;
};

export default ShopifyGraphQLGatewaySwitch;
